



























import { defineComponent, PropType, ref, onMounted } from '@vue/composition-api';
import Slider from 'primevue/slider';
import InputNumber from 'primevue/inputnumber';

type UpdateHandler = (update: { opacity: number }) => { opacity: number };

export default defineComponent({
    name: 'Opacity',
    components: { Slider, InputNumber },
    props: {
        geoRecord: {
            type: Object,
            default: () => ({}),
        },
        handleGeoRecordPropertyUpdate: {
            type: Function as PropType<UpdateHandler>,
            default: () => ({}),
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const DEFAULT_OPACITY = 0.5;
        const localOpacity = ref(props.geoRecord.opacity || DEFAULT_OPACITY);

        const validateOpacity = (value: number): number => {
            return Math.max(0.1, Math.min(1, Math.round(value * 10) / 10));
        };

        const handleSliderChange = (value: number) => {
            const validValue = validateOpacity(value);
            updateOpacity(validValue);
        };

        const handleInputChange = (value: number) => {
            if (!value || value < 0.1) return;
            const validValue = validateOpacity(value);
            updateOpacity(validValue);
        };

        const updateOpacity = (validValue: number) => {
            try {
                const updatedRecord = props.handleGeoRecordPropertyUpdate({
                    opacity: validValue,
                });

                if (
                    updatedRecord &&
                    typeof updatedRecord.opacity === 'number'
                ) {
                    localOpacity.value = updatedRecord.opacity;
                } else {
                    localOpacity.value = validValue;
                }
                emit('input', validValue);
            } catch (error) {
                console.error('Error updating opacity:', error);
            }
        };

        onMounted(async () => {
            const validValue = validateOpacity(localOpacity.value);
            updateOpacity(validValue);
        });

        return {
            localOpacity,
            handleSliderChange,
            handleInputChange,
        };
    },
});
